(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["carey-meridian"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('carey-epk');
  if (!root) return;
  const form = root.querySelector('#inquiry-form');
  const select = form?.querySelector('select[name="interest"]');
  const note = root.querySelector('#meridian-inquiry-note');
  if (!select || !note) return;
  function updateNote() { note.hidden = select.value !== 'Media production / Meridian'; }
  root.addEventListener('click', event => {
    if (event.target.closest('[data-interest]')) updateNote();
  });
  select.addEventListener('change', updateNote);
  form.addEventListener('reset', () => requestAnimationFrame(updateNote));
  updateNote();
})();
  } catch(e) { console.error(e); }
})();

})();
